export enum ScheduleTypes {
    None = 0,
    Custom = 1,
    AfterMarketStart = 2, //Boris, please check and rename variable if needed
    FifteenMinutesBeforeClose = 3, //Boris, please check and rename variable if needed
    FiveMinutesBeforeClose = 4, //Boris, please check and rename variable if needed
    ThirtyMinutesAfterMarketStart = 5, //Boris, please check and rename variable if needed
    MidDay = 6,
    FifteenMinutesAfterMarketStart = 7,
    ThirtyMinutesBeforeClose = 8,
    FifteenMinutesBeforeMidDay = 9,
    FifteenMinutesAfterMidDay = 10,
    ThirtyMinutesAfterMidDay = 11,
    Admin = 12,
}
